import { useId } from 'react';
import FieldFrame from './FieldFrame.jsx';
import { getFieldDescribedBy } from './getFieldDescribedBy.js';

/** Multi-line text field with optional label, hint and error. */
const Textarea = ({ label, hint, error, rows = 4, id: givenId, ...rest }) => {
  const generatedId = useId();
  const id = givenId ?? generatedId;

  return (
    <FieldFrame id={id} label={label} hint={hint} error={error}>
      <textarea {...rest} id={id} rows={rows} className="comp-textarea" aria-invalid={error ? 'true' : undefined} aria-describedby={getFieldDescribedBy({ id, hint, error })} />
    </FieldFrame>
  );
};

export default Textarea;
